module.exports = require('./src');



/*****************
 ** WEBPACK FOOTER
 ** /Users/dlopuch/developer/projects-venture-dealr/~/reflux/index.js
 ** module id = 3
 ** module chunks = 0
 **/